export const SET_ALL_PLATFORM_USERS = 'SET_ALL_PLATFORM_USERS'
export const SET_PLATFORM_SHOW_MODAL = 'SET_PLATFORM_SHOW_MODAL'
export const SET_PLATFORM_COPY_DATA = 'SET_PLATFORM_COPY_DATA'
export const SET_PLATFORM_USERS_IS_LOADING = 'SET_PLATFORM_USERS_IS_LOADING'

